import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import MainLayout from '@/views/layouts/MainLayout.vue'
import CVBuilderView from '@/views/CVBuilderView.vue'
import AccountSettingsView from '@/views/AccountSettingsView.vue'
import SavedJobsView from '@/views/MyJobsView/SavedJobsView.vue'
import AppliedJobsView from '@/views/MyJobsView/AppliedJobsView.vue'
import MonthlySubscriptionView from '@/views/MonthlySubscriptionView.vue'
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue'
import TermsOfServiceView from '@/views/TermsOfServiceView.vue'
import ContactUsView from '@/views/ContactUsView.vue'
import MyJobsView from '@/views/MyJobsView.vue'
import EnterpriseLayout from '@/views/layouts/EnterpriseLayout.vue'
// Auth
import LoginView from '@/views/Auth/LoginView.vue'
import SignUpView from '@/views/Auth/SignUpView.vue'
import EditPasswordView from '@/views/Auth/EditPasswordView.vue'
import ResetPasswordView from '@/views/Auth/ResetPasswordView.vue'
import ForgotPasswordView from '@/views/Auth/ForgotPasswordView.vue'
import VerifyEmailView from '@/views/Auth/VerifyEmailView.vue'
import VerificationLinkView from '@/views/Auth/VerificationLinkView.vue'


//Enterprise
import EnterpriseHomeView from '@/views/EnterpriseViews/EnterpriseHomeView.vue' 
import VacanciesView from '@/views/EnterpriseViews/VacanciesView.vue'
import ShortlistsView from '@/views/EnterpriseViews/ShortlistsView.vue'

//Administrator
import AdministratorLayout from '@/views/layouts/AdministratorLayout.vue'
import JobSeekersView from '@/views/AdministratorViews/JobSeekersView.vue'
import EmployersView from '@/views/AdministratorViews/EmployersView.vue'
import AdminDashboardView from '@/views/AdministratorViews/AdminDashboardView.vue'



import ApplicantsListView from '@/views/EnterpriseViews/ApplicantsViews/ApplicantsListView.vue'
import ShortlistedListView from '@/views/EnterpriseViews/ApplicantsViews/ShortlistedListView.vue'


import PaymentSuccessView from '@/views/PaymentViews/PaymentSuccessView.vue'
import PaymentFailedView from '@/views/PaymentViews/PaymentFailedView.vue'
import PageNotFoundView from '@/views/PageNotFoundView.vue'

import JobPostView from '@/views/JobPostView.vue'
import ProfileView from '@/views/ProfileView.vue'

import SearchResultsView from '@/views/SearchResultsView.vue'

const APP_NAME = "Vocation";

const routes = [
  {
    path: '/',
    component: MainLayout,
    children:[
      {
        path:'/',
        name:'home',
        component: HomeView,
        meta: {
          title: `${APP_NAME} - Home`,
          description:`Discover exceptional career opportunities or gain access to enterprise recruitment tools effortlessly on ${APP_NAME}. Create your account and apply today.`
        }
      },
      {
        path:'/org/:handle',
        name:'public-profile',
        component: ProfileView,
        meta: {
          title: `${APP_NAME} - Profile`,
          description:`View this Vocation Profile on ${APP_NAME}.`
        }
      },
      {
        path:'/about',
        name:'about',
        component: AboutView,
        meta: {
          title: `${APP_NAME} - About Us`,
          description:`Learn about ${APP_NAME}'s mission to modernize job search and recruitment cycles. Discover how we seamlessly connect talent with industry leaders.`
        }
       },
       {
        path:'/search-results',
        name:'search-results',
        component: SearchResultsView,
        meta: {
          title: `${APP_NAME} - Search Results`     
        }
       },
      {
        path:'/cv-builder',
        name:'cv-builder',
        component: CVBuilderView,
        meta: {
          requiresAuth: true,
          roles: ["JobSeeker"],
          title: `${APP_NAME} - CV Builder`
        },
      },
      {
        path:'/my-account',
        name:'my-account',
        component: AccountSettingsView,
         meta: {
          requiresAuth: true,
          roles: ["JobSeeker"],
          title: `${APP_NAME} - My Account`
        }
      },
      {
        path:'/saved-jobs',
        name:'saved-jobs',
        component: SavedJobsView,
        meta: {
          requiresAuth: true,
          roles: ["JobSeeker"],
          title: `${APP_NAME} - Saved Jobs`
        }
      },
      {
        path:'/applied-jobs',
        name:'applied-jobs',
        component: AppliedJobsView,
        meta: {
          requiresAuth: true,
           roles: ["JobSeeker"],
           title: `${APP_NAME} - Applied Jobs`
          }
         },
      {
        path:'/billing',
        name:'billing',
        component: MonthlySubscriptionView,
        meta:{
          title:`${APP_NAME} - Billing`,
          description:`Explore ${APP_NAME} subscription plans. Premium features for Job Seekers to enhances applications, and Enterprise tools for Employers to streamline recruitment.`
        }
       },
      {
        path:'/privacy-policy',
        name:'privacy-policy',
        component: PrivacyPolicyView,
        meta:{
          title: `${APP_NAME} - Privacy Policy`,
          description:`Read the ${APP_NAME} privacy policy to learn how we securely collect, manage, and protect your personal profile data and account information.`
        }
       },
        {
        path:'/terms-of-service',
        name:'terms-of-service',
        component: TermsOfServiceView,
        meta:{
          title: `${APP_NAME} - Terms Of Service`,
          description:`Read more about ${APP_NAME}'s Terms Of Service.`
        }
       },
      {
        path:'/contact-us',
        name:'contact-us',
        component: ContactUsView,
        meta:{
          title: `${APP_NAME} - Contact Us`,
          description:`Have questions or need assistance with your account? Reach out to the ${APP_NAME} support team for quick, dedicated help and technical support.`
        }
       },
      {path:'/myjobs',
        name:'myjobs',
        component: MyJobsView,
        redirect:'/myjobs/applied-jobs',
        meta: {
          requiresAuth: true,
           roles: ["JobSeeker"],
           title: `${APP_NAME} - My Jobs`
          },
        children:[
            {path:'applied-jobs',
              component:AppliedJobsView, meta: {
                requiresAuth: true, roles: ["JobSeeker"],
                title: `${APP_NAME} - Applied Jobs`
              }},
            {path:'saved-jobs',
              component:SavedJobsView, meta: {
                requiresAuth: true, roles: ["JobSeeker"],
                title: `${APP_NAME} - Saved Jobs`
              }},
        ]
      }, //Auth
      {
        path:'/login',
        name:'login',
        component: LoginView,
        meta:{
          title: `${APP_NAME} - Log In`,
          description:`Log in to gain access to your Job Seeker/Enterprise tools and services on ${APP_NAME}`
        }
      },
      {
        path:'/signup',
        name:'signup',
        component: SignUpView,
        meta:{
          title:`${APP_NAME} - Sign Up`,
          description:`Start your journey with us! Sign up for a ${APP_NAME} Job Seeker or Enterprise account.`
        }
       },
       {
        path:'/verification',
        name:'verification',
        component: VerificationLinkView,
        meta:{
          title:`${APP_NAME} - Verification`
        }
       },
      {
        path:'/reset-password',
        name:'reset-password',
        component: ResetPasswordView,
        meta:{
          title:`${APP_NAME} - Reset Password`
        }
      },
      {
        path:'/forgot-password',
        name:'forgot-password',
        component: ForgotPasswordView,
        meta:{
          title: `${APP_NAME} - Forgot Password`
        }
       },
      {
        path:'/edit-password',
        name:'edit-password',
        component: EditPasswordView,
        meta:{
          title:`${APP_NAME} - Edit Password`
        }
       },
      {
        path:'/payment-success',
        name:'payment-success',
        component: PaymentSuccessView,
        meta:{
          title:`${APP_NAME} - Payment Successful`
        }
      },   
      {
        path:'/payment-failed',
        name:'payment-failed',
        component: PaymentFailedView,
        meta:{
          title:`${APP_NAME} - Payment Failed`
        }
      },
      {
        path:'/jobpost/:jobid',
        name:'jobpost',
        component: JobPostView,
        meta:{
          title: `${APP_NAME} - Job Post`
        }
       },
    ]
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: EnterpriseLayout,
    redirect:'/enterprise/home',
     meta: {requiresAuth: true, roles: ["Employer"]},
    children:[
      {path:'home',
        name:'enterprise-home',
        component: EnterpriseHomeView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title:`${APP_NAME} - Enterprise Home`
        }
      },
      {
        path:'my-account',
        name:'enterprise-my-account',
        component: AccountSettingsView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - My Account`
          }
      },
      {
        path:'vacancies',
        name:'enterprise-vacancies',
        component: VacanciesView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - Vacancies`
        }
      },
      {
        path:'billing',
         name:'enterprise-billing',
          component: MonthlySubscriptionView,
           meta: {
            requiresAuth: true,
            roles: ["Employer"],
            title: `${APP_NAME} - Billing`
          }
      },
      {
        path:'contact-us',
        name:'enterprise-contact-us',
        component: ContactUsView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title:`${APP_NAME} - Contact Us`
        }
      },
      {
        path:'privacy-policy',
        name:'enterprise-privacy-policy',
        component: PrivacyPolicyView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title:`${APP_NAME} - Privacy Policy`
        }
      },
      {
        path:'terms-of-service',
        name:'enterprise-terms-of-service',
        component: TermsOfServiceView,
        meta:{
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - Terms Of Service`
        }
       },
      {
        path:'about',
        name:'enterprise-about',
        component: AboutView,
        meta: {
          requiresAuth: true, 
          roles: ["Employer"],
          title: `${APP_NAME} - About Us`
        }
      },
      {
        path:'shortlists',
        name:'shortlists',
        component: ShortlistsView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - Shortlisted Candidates`
        }
      },  
      {
        path:'applicants-list',
        name: 'applicants-list' ,
        component:ApplicantsListView,
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - Applicants`
        }
      },
      {
        path:'shortlisted-list', 
        name: 'shortlisted-list',
        component: ShortlistedListView, 
        meta: {
          requiresAuth: true,
          roles: ["Employer"],
          title: `${APP_NAME} - Shortlisted Candidates`
        }
      },
      
    ]

  },
  { //Administrator
    path: '/admin',
    name: 'admin',
    component: AdministratorLayout,
    redirect: '/admin/dashboard',
    meta: {requiresAuth: true, roles: ["Admin"]},
    children:[
      { path:'dashboard',
         name:'dashboard',
          component: AdminDashboardView,
          meta: {
            requiresAuth: true,
            roles: ["Admin"],
            title: `${APP_NAME} - Administrator | Dashboard`
          }
      }, 
      {
        path:'job-seekers',
        name:'job-seekers',
        component: JobSeekersView,
        meta: {
          requiresAuth: true,
          roles: ["Admin"],
          title: `${APP_NAME} - Administrator | Job Seeker Accounts`
        }
      }, 
      {
        path:'employers',
        name:'employers',
        component: EmployersView,
        meta: {
          requiresAuth: true, 
          roles: ["Admin"],
          title: `${APP_NAME} - Administrator | Employers Accounts`
        }
      }, 
    ]
  },
  {
    path:'/verify-email',
    name:'verify-email',
    component: VerifyEmailView,
    meta:{
      title: `${APP_NAME} - Verifying Email`
    }
  },
  {
    path:'/:pathMatch(.*)*',
    name:'not-found',
    component: PageNotFoundView,
    meta:{
      title: `${APP_NAME} - Page Not Found`
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ----- NAVIGATION GUARD -------

router.beforeEach((to,from,next) => {
  let token = localStorage.getItem("token");
  let userRaw = localStorage.getItem("user");
  let user = null;

  if(userRaw){
    try{
        user = JSON.parse(userRaw); 
      }catch(e){
        // If the token is corrupted, wipe it clean and let them browse public pages
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        return next("/login"); //if getting roles failed
    }
  }
    
        // Check authentication
      if(to.meta.requiresAuth && !token){
        return next("/login"); // not logged in
      }
  


    // Enforce Authorization/Role permissions boundary
  if (to.meta.requiresAuth && to.meta.roles) {    
    const hasRole = user?.roles?.some(role => to.meta.roles.includes(role));
    if (!hasRole) {
      if (user?.roles?.includes("JobSeeker") && to.path !== "/") {
        return next("/");
      }
      if (user?.roles?.includes("Employer") && !to.path.startsWith("/enterprise")) {
        return next("/enterprise/home");
      }
      if (user?.roles?.includes("Admin") && !to.path.startsWith("/admin")) {
        return next("/admin/dashboard");
      }
      // Fail-safe protection if account contains no viable configuration
      return next("/login");
    }
  }

    // Redirect authenticated assets away from public login frames
  if (to.name === "login" && token && user) {
    if (user.roles?.includes("JobSeeker")) return next("/");
    if (user.roles?.includes("Employer")) return next("/enterprise/home");
    if (user.roles?.includes("Admin")) return next("/admin/dashboard");
  }

  next();


});

// ----- NAVIGATION GUARD -------


//----- SEARCH ENGINE OPTIMIZATION -------

// Helper utility to safely create or overwrite HTML meta elements
function updateMetaTag(attrName, attrValue, contentValue) {
  if (!contentValue) return;
  let element = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attrName, attrValue);
    document.head.appendChild(element);
  }
  element.setAttribute('content', contentValue);
}

// Global Document Meta Optimization Engine
router.afterEach((to) => {
  // 1. Publish Browser Window Title
  document.title = to.meta.title || APP_NAME;

  // 2. Resolve Descriptions (Pulling metadata fallback or hardcoded text safely)
  const defaultDesc = `Discover exceptional career opportunities or gain access to enterprise recruitment tools effortlessly on ${APP_NAME}. Create your account and apply today.`;
  const targetDesc = to.meta.description || defaultDesc;

  // 3. Fallback Share Image (Use an absolute URL to your public assets directory)
  const defaultImage = "https://yourdomain.com/assets/default-share-banner.jpg";
  const targetImage = to.meta.image || defaultImage;

  // 4. Resolve Open Graph Content Type
  // Only use 'article' for specialized child content profiles, otherwise 'website' is standard
  const targetType = to.meta.ogType || "website";

  // --- PUBLISH STANDARD SEO META ---
  updateMetaTag('name', 'description', targetDesc);

  // --- PUBLISH OPEN GRAPH (Facebook, LinkedIn, WhatsApp, Slack) ---
  updateMetaTag('property', 'og:title', to.meta.title || APP_NAME);
  updateMetaTag('property', 'og:description', targetDesc);
  updateMetaTag('property', 'og:image', targetImage);
  updateMetaTag('property', 'og:type', targetType);
  updateMetaTag('property', 'og:url', window.location.href);

  // --- PUBLISH TWITTER CARDS (X) ---
  updateMetaTag('name', 'twitter:card', 'summary_large_image');
  updateMetaTag('name', 'twitter:title', to.meta.title || APP_NAME);
  updateMetaTag('name', 'twitter:description', targetDesc);
  updateMetaTag('name', 'twitter:image', targetImage);
});

//----- SEARCH ENGINE OPTIMIZATION -------





export default router
